import QliroUpdate from "./qliroUpdate";
import { 
  ValidateAddress,
  ValidateEmail,
  ValidateGDPRDisclaimer,
  ValidateCity,
  ValidateName,
  ValidatePhone,
  ValidatePostalCode,
  ValidateSecondName
} from "./validators/indexValidator";
import { GetCartInfo, GetCart } from "./cart/components/cart";
import { showErrorModal } from "./common";

class DiscountResultMessage {
  
  #cssClassName = '';
  #messageJqElement = '';
  
  constructor(cssClassName) {
    this.#cssClassName = cssClassName;
    
    if (!this.#cssClassName.startsWith(".")) {
      this.#cssClassName = '.' + this.#cssClassName;
    }
    
    this.#messageJqElement = $(this.#cssClassName);
  }
  
  /**
   *
   * @param {string} message
   */
  showSuccess(message) {
    this.#messageJqElement.html(message);
    this.#messageJqElement.removeClass('error').addClass('success');
    this.#messageJqElement.css('display', 'block');
  }
  
  /**
   *
   * @param {string} message
   */
  showError(message) {
    this.#messageJqElement.html(message);
    this.#messageJqElement.removeClass('success').addClass('error')
    this.#messageJqElement.css('display', 'block')
  }
  
  hide() {
    this.#messageJqElement.html('');
    this.#messageJqElement.removeClass('success').removeClass('error');
    this.#messageJqElement.css('display', '');
  }
}

export default function checkoutJs() {
  $(function () {
    if ($(".offers").length > 0 && $(".offers").data("iscrosssell") == "True") {
      GetCrossSellProducts($(".offers").data("ordernumber"));
    }
    
    const discountResultMessage = new DiscountResultMessage("discount-result-message");
    
    $(document).on('click', '.presentkord-drop .submit-voucher', e => submitVoucher(e));
    $(document).on('click', '.checkout-total-info #m_sendOrder', async (e) => await sendOrder(e));
    $(document).on('change', '.basket_user-choice-hodler > .form-group input', e => basketUserChoiceHolder(e));
    $(document).on('click', '.open-presentkord-drop', e => openPresentkordDrop(e));
    $(document).on('change', 'input[id^="additional-service-"]', e => additionalService(e))
    
    $(document).on('change', '.country_select', function (e) {
      CountryChange($(this));
    });
    
    function submitVoucher (e) {
      var code = $(".presentkord-drop .voucherCode").val();
      discountResultMessage.hide();
      $('.presentkord-drop .submit-voucher').prop('disabled', true);
      e.preventDefault();
      e.stopPropagation();
      if (!code) {
        discountResultMessage.showError("Fältet är tomt")
        $('.presentkord-drop .submit-voucher').prop('disabled', false);
        return false;
      }
      DisableControls();
      $.ajax({
        type: "POST",
        url: "/api/checkout/DiscountChange",
        data: JSON.stringify(code),
        contentType: "application/json",
        success: function (data) {
          if (data) {
            if (data.ErrorMessage) {
              GetCartInfo();
              discountResultMessage.showError(data.ErrorMessage)
              $('.presentkord-drop .submit-voucher').prop('disabled', false);
            }
            if (data.SuccessMessage) {
              if (location.pathname.startsWith('/checkout/payment')) {
                location.reload();
              } else {
                GetCartInfo(GetCart(false, function () {
                  if ($(".tab-content .QliroCheckout").length) {
                    QliroUpdate();
                  }
                }));
                
                discountResultMessage.showSuccess(data.SuccessMessage);
                $(".presentkord-drop .voucherCode").val("");
                $(this).val("");
              }
            }
          }
        }
      });
    }
  
    function CountryChange(select) {
      DisableControls();
      var selectedCountry = $(select, 'option:selected').val();
      if (!selectedCountry) {
        return;
      }
      $.ajax({
        type: "POST",
        url: "/api/checkout/CountryChange",
        data: JSON.stringify(selectedCountry),
        contentType: "application/json",
        success: function (data) {
          if (data) {
            if (data.Message != null) {
              showErrorModal(data.Message, "window.location.href = '" + data.RedirectUrl + "';");
              return;
  
            }
  
            if (data.RedirectUrl) {
              if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                var isReload = false;
                isReload = window.location.pathname == data.RedirectUrl;
                window.location.href = data.RedirectUrl + '#CountryIdentifier';
                if (isReload) {
                  window.location.reload();
                }
                return;
              } else {
                window.location.href = data.RedirectUrl;
                return;
              }
            }
          }
        }
      });
    }

    function ShippingChange(btn) {
      $(".delivery-table input[type=radio]").not("#" + btn.val()).prop('checked', false);

      discountResultMessage.hide();
      
      DisableControls();

      $.ajax({
        type: "POST",
        url: "/api/checkout/CartShippingTypeChange",
        data: JSON.stringify(btn.val()),
        contentType: "application/json",
        success: function (data) {

          GetCartInfo(GetCart(false));
        }
      });
    }
    
    function basketUserChoiceHolder (e) {
      var obj = {};
      obj.IsNewsletter = $(".basket_user-choice-hodler #IsNewsletter").is(":checked");
      obj.IsCatalog = $(".basket_user-choice-hodler #IsCatalog").is(":checked");
      $.ajax({
        type: "POST",
        url: "/api/checkout/SubscriptionChange",
        data: JSON.stringify(obj),
        contentType: "application/json",
        success: function () {
          if ($(".tab-content .QliroCheckout").length) {
            QliroUpdate();
          }
        }
      });
    }
    
    async function sendOrder (e) {
      e.preventDefault();
      
      var valid = true;
      var Name = $(".payment-form input[id$='tbxName']");
      var SecondName = $(".payment-form input[id$='tbxSecondName']");
      var Phone = $(".payment-form input[id$='tbxPhone']");
      var Email = $(".payment-form input[id$='tbxEmail']");
      var Address = $(".payment-form input[id$='tbxAddress']");
      var Zip = $(".payment-form input[id$='tbxPostNumber']");
      var City = $(".payment-form input[id$='tbxCity']");
      var Country = $(".country-select select[id$='m_country']");
      var Company = $(".payment-form input[id$='tbxCompanyName']");
      var Attention = $(".payment-form input[id$='tbxAttention']");
      var PersonNumber = $(".payment-form input[id$='tbxRegistrationNumber']");
      var PersonNumberText = PersonNumber.val();
      var GDPRDisclaimer = $(".payment-form input[id$='cbGDPRDisclaimer']");
      var sendOrderBtn = $(".checkout-total-info #m_sendOrder");
      
      
      var validArr = [];
      if (GDPRDisclaimer.length) {
        validArr.push(ValidateGDPRDisclaimer(GDPRDisclaimer))
      }
      if (PersonNumber.length) {
        validArr.push(await ValidatePersonNumber(PersonNumber));
      }
      else {
        PersonNumberText = "";
      }
      if (Name.length) {
        validArr.push(ValidateName(Name));
      }
      if (SecondName.length) {
        validArr.push(ValidateSecondName(SecondName));
      }
      if (Zip.length) {
        validArr.push(ValidatePostalCode(Zip));
      }
      if (Email.length) {
        validArr.push(ValidateEmail(Email));
      }
      if (Phone.length) {
        validArr.push(ValidatePhone(Phone));
      }
      if (Address.length) {
        validArr.push(ValidateAddress(Address));
      }
      if (City.length) {
        validArr.push(ValidateCity(City));
      }
      if (Country.length) {
        validArr.push(ValidateCountry(Country));
      }
      if (Company.length) {
        validArr.push(ValidateCompanyName(Company));
      }
      for (var i = 0; i < validArr.length; i++) {
        if (!validArr[i]) {
          valid = false;
          break;
        }
      }
      
      if (valid) {
        sendOrderBtn.addClass("show-loader");
        sendOrderBtn.prop('disabled', true);
        
        if (typeof (fbq) != 'undefined') { fbq('track', 'AddPaymentInfo'); }
        var obj = {};
        obj.FirstName = Name.length ? Name.val() : "";
        obj.LastName = SecondName.length ? SecondName.val() : "";
        obj.CompanyName = Company.length ? Company.val() : "";
        obj.Attention = Attention.length ? Attention.val() : "";
        
        obj.Phone = Phone.length ? Phone.val() : "";
        obj.Email = Email.length ? Email.val() : "";
        
        obj.Address = Address.length ? Address.val() : "";
        obj.Zip = Zip.length ? Zip.val() : "";
        obj.City = City.length ? City.val() : "";
        obj.CountryValue = Country.length ? Country.val() : "";
        
        obj.IsCatalog = $("input[id$='m_catalogue']").is(':checked');
        obj.IsNewsletter = $("input[id$='m_newsletter']").is(':checked');
        obj.PaymentIdentifier = $(".checkout-total-info #m_sendOrder").data("paymentidentifier");
        obj.BankIdentifier = $("table[id$='rblBanks'] tr td input:checked").val();
        obj.PersonNumber = PersonNumberText;
        $.ajax({
          data: JSON.stringify(obj),
          async: true,
          contentType: "application/json",
          type: "POST",
          url: "/api/checkout/SendOrder",
          success: function (data) {
            if (data != null) {
              if (data.RedirectUrl) {
                window.location.href = data.RedirectUrl;
                return;
              }
              if (data.Message) {
                showErrorModal(data.Message);
              }
            }
          }
        });
      }
      return false;
    }
    
    function openPresentkordDrop (e) {
      e.preventDefault();
      $('.open-presentkord-drop>svg').toggleClass('arrowUp');
      $('.presentkord-drop').toggle();
      return false;
    }
  
  
    if ($(".tab-content .QliroCheckout").length) {
        QliroUpdate();
    }
    
    function additionalService (e) {
      const apiUrl = $(e.target).data("additionalserviceapi")
      const isChecked = e.target.checked;
      
      discountResultMessage.hide();
      
      $.ajax({
        data: JSON.stringify(isChecked),
        async: true,
        contentType: "application/json",
        type: "POST",
        url: apiUrl,
        beforeSend: function () {
          DisableControls();
        },
        complete: function () {
          $(".checkout-total-info #m_sendOrder").removeClass("show-loader")
        },
        success: function (data) {
          if (!data) {
            e.target.checked = false;
          }
          
          GetCartInfo(GetCart(false));
        }
      })
    }
  });
}

export function DisableControls() {
  let shippingPageToPaymentBtn = $("#ShippingPageToPaymentBtn");
  shippingPageToPaymentBtn.removeClass("btn-disabled");
  shippingPageToPaymentBtn.addClass("show-loader");
  $("#CartPageToShippingBtn").addClass("show-loader");
  $('#CartContinueShipping').addClass("btn-disabled");
  $('#ShippingPageReturnToCartBtn').addClass("btn-disabled");
  $('.presentkord-drop .submit-voucher').prop('disabled', true);
  $('.func-cart-shipping-selector').prop('disabled', true);
  $('.country_select').prop('disabled', true);
  $(".basket-table-wrapper .basket-table .productItem").addClass("disabled");
  $('input[id^="additional-service-"]').prop('disabled', true);
}
